import { injectI18n } from 'utils/i18n'
import { Error } from 'components/Error'
import type { GetStaticProps } from 'next'
import type { ReactNode } from 'react'

interface PageProps {}
export const getStaticProps: GetStaticProps<PageProps> = async context => {
  const i18n = await injectI18n(context.locale, [
    'errors.page',
    'footer.component',
    'metadata',
    'nav.component',
  ])

  return {
    props: {
      ...i18n,
    },
  }
}

export default function Page404(): ReactNode {
  return <Error statusCode={404} />
}
